module.exports = __webpack_public_path__ + "assets/img/repeat.7f99361c.svg";